import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import './ZeroProofPage.css';
import './HomePage.css';

import longevityChecklistLogo from './images/ZeroProofLogo.png';
import qrImage from './images/ZeroProofQrCode.png';

const Modal = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>×</button>
                {children}
            </div>
        </div>
    );
};

const PrivacyPage = () => {
    const navigate = useNavigate();

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isQRModalOpen, setIsQRModalOpen] = useState(false);

    const handleBurgerClick = (e) => {
        setIsMenuOpen(e.target.checked);
    };

    return (
        <div className="container">
            <div className="glass-header">
                <div className="header-content">
                    <div className="logo-container">
                        <img
                            src={longevityChecklistLogo}
                            alt="Longevity Checklist Logo"
                            className="logo-image"
                            onClick={() => window.scrollTo(0, 0)}
                        />
                    </div>

                    <div className="header-controls">
                        {/* <button
                            className="qr-button"
                            onClick={() => setIsQRModalOpen(true)}
                        >
                            <QrCode size={24} />
                            <span>Download</span>
                        </button> */}

                        <label className="burger" htmlFor="burger">
                            <input
                                type="checkbox"
                                id="burger"
                                checked={isMenuOpen}
                                onChange={handleBurgerClick}
                            />
                            <span></span>
                            <span></span>
                            <span></span>
                        </label>
                    </div>

                    {isMenuOpen && (
                        <div className="dropdown-menu">
                            <div className="menu-item" onClick={() => navigate('/')}>Home</div>
                            {/* <div
                                className="menu-item"
                                onClick={() => document.querySelector('.features-section').scrollIntoView({ behavior: 'smooth' })}
                            >
                                Features
                            </div> */}
                            <div
                                className="menu-item"
                                onClick={() => window.open('https://apps.apple.com/us/app/zero-proof/id6742756239?itscg=30200&itsct=apps_box_link&mttnsubad=6742756239', '_blank')}
                            >
                                Download
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <Modal isOpen={isQRModalOpen} onClose={() => setIsQRModalOpen(false)}>
                <div className="qr-container">
                    <h2 className="qr-title">Scan to Download</h2>
                    <img
                        src={qrImage}
                        alt="QR Code"
                        className="qr-code"
                    />
                    <p className="qr-description">Scan this QR code with your mobile device to download the app</p>
                </div>
            </Modal>

            <div className="privacy-policy-container">
                <h1 className="privacy-policy-title">Privacy Policy for Zero Proof</h1>
                <p className="privacy-policy-update-date">Last updated: March 10, 2025</p>

                <section className="privacy-section">
                    <h3 className="privacy-subtitle">Information We Collect</h3>
                    <p className="privacy-text">
                        Zero Proof uses Mixpanel, a third-party analytics service, to collect anonymous usage data. This data may include information such as how often you use the app, the events that occur within the app, aggregated usage, performance data, and what app store you used to download the app. Mixpanel may also collect your IP address to determine your approximate location, but does not store the IP address itself. Zero Proof does not collect or store any personally identifiable information through Mixpanel. The data collected is used solely for analytics purposes to improve the app and provide a better user experience.
                    </p>
                </section>

                <section className="privacy-section">
                    <h3 className="privacy-subtitle">Your Rights</h3>
                    <p className="privacy-text">
                        Our site may, from time to time, contain links to websites of partner networks, advertisers, or affiliates. If you follow a link to any of these websites, please note that they have their own privacy policies, and we do not accept responsibility for these policies. Please review them before submitting any personal data to these websites.
                    </p>
                </section>

                <section className="privacy-section">
                    <h3 className="privacy-subtitle">Third-Party Services</h3>
                    <p className="privacy-text">
                        Zero Proof uses third-party services, such as Mixpanel, to collect anonymous usage data. These services may collect certain data on our behalf, including IP addresses for geolocating purposes. For more information on how Mixpanel handles your data, please refer to their privacy policy at <a href="https://mixpanel.com/legal/privacy-policy/" target="_blank" rel="noopener noreferrer">https://mixpanel.com/legal/privacy-policy/</a>. Zero Proof does not collect or store any personally identifiable information through these services, and the data collected is used only in an aggregated and anonymized form.
                    </p>
                </section>

                <section className="privacy-section">
                    <h3 className="privacy-subtitle">Updates to the Privacy Policy</h3>
                    <p className="privacy-text">
                        We may update this Privacy Policy from time to time to reflect changes in our practices or for operational, legal, or regulatory reasons. Any changes we make will be posted on this page.
                    </p>
                </section>

                <section className="privacy-section">
                    <h3 className="privacy-subtitle">Disclaimer</h3>
                    <p className="privacy-text">
                        Zero Proof provides general information and guidance to promote healthy living. It is not a substitute for professional medical advice, diagnosis, or treatment. Always consult a qualified healthcare provider for personalized medical advice.
                    </p>
                </section>
            </div>

            <footer className="footer">
                <div className="footer-container">
                </div>
                {/* <p className="footer-credits">Made with Love ❤️</p> */}
                {/* <p className="footer-credits">© 2025 Tantalum Technology Corp. All Rights Reserved.</p> */}
            </footer>
        </div>
    );
};

export default PrivacyPage;